module.exports = __webpack_public_path__ + "img/24.eebe6a15.jpg";